module.exports = __webpack_public_path__ + "static/img/14000072.069e0ea3.png";